<div class="bg-aux-gray-light">
  <div class="px-7 pt-8">
    <div class="flex items-center justify-between">
      <h1 class="h-11 text-2xl font-bold text-aux-gray-darkest">Settings</h1>
      <div class="flex">
        @if ((editMode | async) === false) {
          <button
            [disabled]="(hasTrialSettingsPermission$ | async) === false"
            class="btn--primary pl-3"
            (click)="onEditMode()"
            [auxTooltip]="
              (hasTrialSettingsPermission$ | async) === false ? editButtonDisabledTooltip : ''
            "
          >
            <aux-icon name="Pencil" class="mr-2" />
            Edit
          </button>
        }
        @if ((editMode | async) === true) {
          <button
            class="btn--success pl-3"
            (click)="triggerSave()"
            [disabled]="saveButtonDisabled()"
            [auxTooltip]="saveButtonTooltip()"
          >
            <aux-icon name="Check" class="mr-2" />
            Save
          </button>
        }
        @if ((editMode | async) === true) {
          <button class="btn--secondary mx-4" type="button" (click)="editModeCancel()">
            Cancel
          </button>
        }
      </div>
    </div>
    <div class="flex space-x-2">
      <ng-container [ngTemplateOutlet]="service.rightSideContainer | async" />
    </div>
  </div>
  <div class="border-b px-7 py-4">
    <div class="-ml-1 flex">
      <aux-icon name="InfoCircle" class="mr-2" />
      <h2 class="h-9 text-xl font-bold text-aux-gray-darkest">Trial Info</h2>
    </div>
    @if ((editMode | async) === false) {
      @if (currentTrial) {
        <div class="col-span-1 grid grid-cols-20 gap-5 pr-4 tabular-nums">
          <div class="col-span-4">
            <label for="workspace_type" class="mb-1 block text-xs">Workspace Type</label>
            <span [title]="currentTrial.workspace_type">
              <input
                type="text"
                class="block h-10 w-full rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
                id="workspace_type"
                [disabled]="true"
                placeholder="{{ workspaceEnum[currentTrial.workspace_type] }}"
              />
            </span>
          </div>
          <div class="col-span-4">
            <label for="nct_id" class="mb-1 block text-xs">Trial Name</label>
            <span [title]="currentTrial.nct_id">
              <input
                type="text"
                class="block h-10 w-full rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
                id="nct_id"
                [disabled]="true"
                placeholder="{{ currentTrial.nct_id }}"
              />
            </span>
          </div>
          <div class="col-span-4">
            <label for="short_name" class="mb-1 block text-xs">Trial Short Name</label>
            <span [title]="currentTrial.short_name">
              <input
                type="text"
                class="block h-10 w-full rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
                id="short_name"
                [disabled]="true"
                placeholder="{{ currentTrial.short_name }}"
              />
            </span>
          </div>
          <div class="col-span-4">
            <label for="trial_status" class="mb-1 block text-xs">Auxilius Trial Status</label>
            <ng-select
              id="trial_status"
              class="select h-10 text-sm text-aux-gray-lightest/75"
              [ngModel]="currentTrial.implementation_status"
              bindLabel="label"
              bindValue="value"
              label="Implementation Status"
              auxFormError
              [items]="implementationStatusOptions"
              [clearable]="false"
              [searchable]="false"
              [disabled]="true"
              [multiple]="false"
              [required]="false"
            />
          </div>
          <div class="col-span-4">
            <label for="start_date" class="mb-1 block text-xs">Auxilius Start Date</label>
            <input
              type="text"
              class="block h-10 w-full rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
              id="start_date"
              [disabled]="true"
              placeholder="{{ currentTrial.auxilius_start_date }}"
            />
          </div>
          <!-- Sponsor, Indication, Program, Project. -->
          <div class="col-span-4">
            <label for="organization_name" class="mb-1 block text-xs">Sponsor</label>
            <span [title]="currentTrial.sponsor_organization.name">
              <input
                type="text"
                class="block h-10 w-full rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
                id="organization_name"
                [disabled]="true"
                placeholder="{{ currentTrial.sponsor_organization.name }}"
              />
            </span>
          </div>

          <div class="col-span-4">
            <div class="mb-1 block text-xs">Therapy Area</div>
            <aux-multi-select-dropdown
              placeholder=""
              [items]="therapyAreaOptions"
              [ngModel]="currentTrial.therapy_area"
              class="w-full text-aux-gray-lightest/75"
              [searchable]="true"
              bindLabel="label"
              bindValue="value"
              [required]="true"
              [disabled]="true"
            ></aux-multi-select-dropdown>
          </div>

          <div class="col-span-4">
            <label for="indication" class="mb-1 block text-xs">Indication</label>
            <span [title]="currentTrial.indication">
              <input
                type="text"
                class="block h-10 w-full rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
                id="indication"
                [disabled]="true"
                placeholder="{{ currentTrial.indication }}"
              />
            </span>
          </div>

          <div class="col-span-4">
            <div class="mb-1 block text-xs">Trial Phase</div>
            <ng-select
              class="select custom-outline h-10 text-sm text-aux-gray-lightest/75"
              [ngModel]="getTrialPhaseValue()"
              bindLabel="label"
              bindValue="value"
              [items]="trialPhaseOptions"
              [clearable]="false"
              [searchable]="false"
              [disabled]="true"
              [multiple]="false"
              [required]="false"
            />
          </div>

          <div class="col-span-4">
            <label for="trial_program" class="mb-1 block text-xs">Program</label>
            <span [title]="currentTrial.program">
              <input
                type="text"
                class="block h-10 w-full rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
                id="trial_program"
                [disabled]="true"
                placeholder="{{ currentTrial.program }}"
              />
            </span>
          </div>
          <div class="col-span-4">
            <label for="trial_project" class="mb-1 block text-xs">Project</label>
            <span [title]="currentTrial.project">
              <input
                type="text"
                class="block h-10 w-full rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
                id="trial_project"
                [disabled]="true"
                placeholder="{{ currentTrial.project }}"
              />
            </span>
          </div>
        </div>
      }
    }

    @if ((editMode | async) === true) {
      @if (currentTrial) {
        <form [formGroup]="fg" (ngSubmit)="onSaveEdits()">
          <div class="col-span-1 grid grid-cols-20 gap-5 pr-4 tabular-nums">
            <!-- Workspace Type, Trial Name, Trial Short Name, Auxilius Trial Status, Auxilius Start Date -->
            <div class="col-span-4">
              <div class="mb-1 block text-xs">
                Workspace Type
                <span class="font-bold text-aux-error">*</span>
              </div>
              <ng-select
                #selectWT
                class="select custom-outline h-10 text-sm"
                [ngClass]="selectWT.isOpen ? '' : 'text-aux-gray-lightest/75'"
                formControlName="workspace_type"
                bindLabel="label"
                bindValue="key"
                label="Workspace Type"
                auxFormError
                [items]="workspaceTypeOptions"
                [clearable]="false"
                [searchable]="false"
                [disabled]="false"
                [multiple]="false"
                [required]="false"
              />
            </div>
            <div class="col-span-4">
              <label for="nct_id_edit" class="mb-1 block text-xs">
                Trial Name
                <span class="font-bold text-aux-error">*</span>
              </label>
              <span [title]="currentTrial.nct_id">
                <input
                  type="text"
                  class="block h-10 w-full rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
                  id="nct_id_edit"
                  [disabled]="true"
                  placeholder="{{ currentTrial.nct_id }}"
                />
              </span>
            </div>
            <div class="col-span-4">
              <aux-input
                formControlName="short_name"
                label="Trial Short Name"
                [showRequiredAsterisk]="true"
                [validators]="trialShortNameValidators"
              />
            </div>
            <div class="col-span-4">
              <label for="trial_status_edit" class="mb-1 block text-xs">
                Auxilius Trial Status
                <span class="font-bold text-aux-error">*</span>
              </label>
              <ng-select
                #select
                id="trial_status_edit"
                class="select custom-outline h-10 text-sm"
                formControlName="implementation_status"
                bindLabel="label"
                bindValue="value"
                label="Implementation Status"
                auxFormError
                [ngClass]="select.isOpen ? '' : 'text-aux-gray-lightest/75'"
                [items]="implementationStatusOptions"
                [clearable]="false"
                [searchable]="false"
                [disabled]="false"
                [multiple]="false"
                [required]="false"
              />
            </div>
            <div class="col-span-4">
              <aux-input
                label="Auxilius Start Date"
                class="grow"
                formControlName="auxilius_start_date"
                [type]="'date'"
              />
            </div>
            <div class="col-span-4">
              <label for="organization_name_edit" class="mb-1 block text-xs">
                Sponsor
                <span class="font-bold text-aux-error">*</span>
              </label>
              <span [title]="currentTrial.sponsor_organization.name">
                <input
                  type="text"
                  class="block h-10 w-full rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
                  id="organization_name_edit"
                  [disabled]="true"
                  placeholder="{{ currentTrial.sponsor_organization.name }}"
                />
              </span>
            </div>

            <div class="col-span-4">
              <aux-multi-select-dropdown
                label="Therapy Area"
                placeholder=""
                [items]="therapyAreaOptions"
                formControlName="therapy_area"
                class="w-full"
                [searchable]="true"
                [clearable]="true"
                bindLabel="label"
                bindValue="value"
                [required]="true"
                [requiredLabel]="true"
                auxFormError
              ></aux-multi-select-dropdown>
            </div>

            <div class="col-span-4">
              <aux-input
                formControlName="indication"
                label="Indication"
                validators="required"
                [showRequiredAsterisk]="true"
              />
            </div>

            <div class="col-span-4">
              <div class="mb-1 block text-xs">
                Trial Phase
                <span class="font-bold text-aux-error">*</span>
              </div>
              <ng-select
                #selectTP
                class="select custom-outline h-10 text-sm"
                [ngClass]="selectTP.isOpen ? '' : 'text-aux-gray-lightest/75'"
                formControlName="trial_phase"
                bindLabel="label"
                bindValue="value"
                label="Trial Phase"
                data-pendo-id="trial-phase-edit-trial"
                auxFormError
                [items]="trialPhaseOptions"
                [required]="true"
                [clearable]="false"
                [searchable]="true"
                [disabled]="false"
                [multiple]="false"
              />
            </div>
            <div class="col-span-4">
              <aux-input class="grow" formControlName="program" label="Program" />
            </div>
            <div class="col-span-4">
              <aux-input class="grow" formControlName="project" label="Project" />
            </div>
            <button #saveButton class="hidden"><span></span></button>
          </div>
        </form>
      }
    }
  </div>
</div>

<div>
  <div class="mb-6 border-b bg-aux-gray-light pl-4">
    <aux-route-tab-group [tabs]="tabs" />
  </div>

  <div class="px-7 pb-7">
    <router-outlet />
  </div>
</div>
